// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__QWdRW","title":"Sidebar_title__+X1Wl","navList":"Sidebar_navList__aEsQm","navLink":"Sidebar_navLink__Ihj8a","navLinkActive":"Sidebar_navLinkActive__gEhUx"};